import { ITranslations } from 'types/common';
import { NoCountriesTransFields } from './types';
import en from 'translations/en/noCountries.json';
import pl from 'translations/pl/noCountries.json';
import sl from 'translations/sl/noCountries.json';

export const noCountriesTranslations: ITranslations<NoCountriesTransFields> = {
  name: 'noCountries',
  en,
  pl,
  sl,
};
